import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { LogoBeelineColor, LogoOdnoklassnikiRoundColor, LogoTelegramRoundColor, LogoVkRoundColor, LogoWhatsappRound } from '@carnica/graphics';
import { MessengersMenuFlags } from "../types";
export var messengerName = {
  beeline: 'beeline',
  telegram: 'telegram',
  whatsapp: 'whatsapp',
  odnoklassniki: 'odnoklassniki',
  vkontakte: 'vkontakte'
};
export var mappedMessangerNames = {
  IS_CHAT_TELEGRAM_ENABLED: messengerName.telegram,
  IS_CHAT_WHATSAPP_ENABLED: messengerName.whatsapp,
  IS_CHAT_CHAT_ENABLED: messengerName.beeline,
  IS_CHAT_OK_ENABLED: messengerName.odnoklassniki,
  IS_CHAT_VK_ENABLED: messengerName.vkontakte
};
export var mappedMessangerData = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, MessengersMenuFlags.IS_CHAT_CHAT_ENABLED, {
  tagName: 'button',
  label: 'в чате поддержки',
  icon: LogoBeelineColor,
  attributes: {
    title: 'Написать в чат',
    'aria-label': 'Написать в чат'
  }
}), MessengersMenuFlags.IS_CHAT_OK_ENABLED, {
  tagName: 'a',
  icon: LogoOdnoklassnikiRoundColor,
  label: 'в Одноклассники',
  attributes: {
    title: 'Поддержка в Одноклассниках',
    href: 'https://ok.ru/beeline',
    'aria-label': 'Поддержка в Одноклассниках'
  }
}), MessengersMenuFlags.IS_CHAT_VK_ENABLED, {
  tagName: 'a',
  icon: LogoVkRoundColor,
  label: 'во ВКонтакте',
  attributes: {
    title: 'Поддержка во ВКонтакте',
    href: 'https://vk.me/beeline',
    'aria-label': 'Поддержка во ВКонтакте'
  }
}), MessengersMenuFlags.IS_CHAT_TELEGRAM_ENABLED, {
  tagName: 'a',
  icon: LogoTelegramRoundColor,
  label: 'в Telegram',
  attributes: {
    title: 'Поддержка в Telegram',
    href: 'https://t.me/BeelineRussia_bot',
    'aria-label': 'Поддержка в Telegram'
  }
}), MessengersMenuFlags.IS_CHAT_WHATSAPP_ENABLED, {
  tagName: 'a',
  icon: LogoWhatsappRound,
  label: 'в WhatsApp',
  attributes: {
    title: 'Поддержка в WhatsApp',
    'aria-label': 'Поддержка в WhatsApp',
    href: 'https://wa.me/79651100611'
  }
});